
import Vue, { PropType } from 'vue';
import { Youtube } from 'vue-youtube';
import tracking from '@/functions/tracking';

interface Data {
    pristine: boolean;
    videoEndedTracked: boolean;
}

export default {
    name: 'm-youtube',
    components: {
        Youtube,
    },

    props: {
        videoTitle: {
            type: String as PropType<string>,
            default: () => '',
        },
        youtubeId: {
            type: String as PropType<string>,
            default: () => '',
        },
    },

    data(): Data {
        return {
            pristine: true,
            videoEndedTracked: false,
        };
    },

    methods: {
        /**
         * Handle tracking for video
         *
         * @return {void}
         */
        playing(): void {
            if (this.pristine) {
                this.trackVideoStart();
                this.pristine = false;
            }
        },
        /**
         * Handle tracking for video
         *
         * @return {void}
         */
        trackVideoStart(): void {
            tracking.trackRawEvent({
                event: 'trackVideo',
                eventData: {
                    category: 'Video modul - YouTube',
                    action: 'Video start',
                    label: this.videoTitle,
                },
            });
        },
        /**
         * Handle tracking for video on ended
         *
         * @return {void}
         */
        trackingVideoEnded(): void {
            if (this.videoEndedTracked) return; // Prevent multiple tracking calls
            this.videoEndedTracked = true;
            tracking.trackRawEvent({
                event: 'trackVideo',
                eventData: {
                    category: 'Video modul - YouTube',
                    action: 'Video slut',
                    label: this.videoTitle,
                },
            });
        },
    },
};
